import { ApiService } from '@libs-uuif/shared/api-service';
import { sessionStorageKeeperService } from '../auth-service';

const urlPostfix = '/api';

export class CcApiService {
  ccApiWrapper = new ApiService();

  fetchCcToken() {
    return sessionStorageKeeperService.retrieve('ccToken') || '';
  }

  getDefaultHeaders() {
    return {
      Authorization: this.fetchCcToken(),
    };
  }

  getSsoToken(baseUrl: string, data: any) {
    const ccBaseUrl = `${baseUrl}${urlPostfix}`;
    this.ccApiWrapper = new ApiService(ccBaseUrl);
    return this.ccApiWrapper.post<any>('/auth/sso', data);
  }

  getApiData(endpoint: string, params: any) {
    return this.ccApiWrapper.get<any>(endpoint, {
      params,
      headers: { Authorization: this.fetchCcToken() },
    });
  }

  activateTenant(tenantId: string) {
    return this.ccApiWrapper.post<any>(
      '/user/activeTenant',
      { tenantId },
      { headers: { ...this.getDefaultHeaders() } },
    );
  }

  getAllTenants() {
    return this.ccApiWrapper.get<any>('/tenant/assign', {
      headers: { ...this.getDefaultHeaders() },
    });
  }

  createReport(endpoint: string, data: any, params: any) {
    return this.ccApiWrapper.post<any>(endpoint, data, {
      params,
      headers: { Authorization: this.fetchCcToken() },
    });
  }
}

export const ccApiService = new CcApiService();
